/**
 * @GENERATED from Figma node 3608:51033
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const JiraDark = function (props: IconProps, ref: React.Ref<SVGSVGElement>) {
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <g clipPath={`url(#${_id3})`}>
        <path
          fill="#2684FF"
          d="M23.326 11.337 12.978.994 11.983 0l-7.76 7.757-3.55 3.547c-.364.364-.364.961 0 1.359l7.098 7.094L11.983 24l7.761-7.757.133-.133 3.45-3.447a.94.94 0 0 0 0-1.326m-11.343 4.21L8.435 12l3.548-3.547L15.533 12z"
        />
        <path
          fill={`url(#${_id})`}
          d="M11.984 8.453c-2.322-2.32-2.322-6.1-.034-8.42L4.19 7.79 8.401 12z"
        />
        <path
          fill={`url(#${_id2})`}
          d="m15.532 12-3.549 3.547c2.322 2.32 2.322 6.1 0 8.453l7.794-7.79z"
        />
      </g>
      <defs>
        <linearGradient
          id={_id}
          x1={11.351}
          x2={6.397}
          y1={4.86}
          y2={9.816}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.176} stopColor="#0052CC" />
          <stop offset={1} stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id={_id2}
          x1={12.662}
          x2={17.606}
          y1={19.089}
          y2={14.143}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.176} stopColor="#0052CC" />
          <stop offset={1} stopColor="#2684FF" />
        </linearGradient>
        <clipPath id={_id3}>
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(JiraDark);
export { ForwardRef as JiraDark };
